import { useSubsStore } from '@/state/MsgTreeProvider'

export function PooInstructions() {
  const { state } = useSubsStore()
  const protocol = state.pooProtocol
  if (!protocol) return null
  const basic = protocol.evidenceProfileId === 'basic-internal'
  const strong = protocol.evidenceProfileId === 'strong-external'
  return (
    <section data-md-contract="poo.instructions" className="mb-6 rounded-xl border border-[#bfcfc8] bg-[#f8fbf9] p-5 shadow-[0_1px_3px_rgba(28,40,36,0.05)] sm:p-7">
      <div className="text-[10px] font-bold uppercase tracking-[0.2em] text-[#557168]">How OPP v{protocol.protocolVersion} {basic ? 'Basic' : strong ? 'Strong' : 'legacy'} works</div>
      <h2 className="mt-1 text-xl font-semibold text-[#1d2a26]">Frozen parties, one user-held code, two independent actions</h2>
      <div className="mt-4 grid gap-5 text-sm leading-6 text-[#596660] lg:grid-cols-2">
        <div>
          <h3 className="font-semibold text-[#26332f]">Registration and opening</h3>
          <p className="mt-1">
            {basic
              ? 'The authenticated internal MsgDesk recipient registers purpose-separated commitments on this page. No external-email reply is required. Open later submits only the matching opening reveal, records it once, and releases Part 2 after enrollment and opening anchors are acknowledged.'
              : strong
                ? 'The sender first attests the exact frozen offer from their external mailbox. The recipient then registers both commitments from their independently authenticated external mailbox. High-value users can derive commitments and one-time reveals in the downloadable offline tool, keeping the master code outside MsgDesk JavaScript.'
                : 'The recipient registers purpose-separated commitments through an authenticated external-email reply. The email registers commitments only; it never opens or accepts the document.'}
          </p>
        </div>
        <div>
          <h3 className="font-semibold text-[#26332f]">Acceptance, delivery, and dispute</h3>
          <p className="mt-1">
            Acceptance is a separate button shown only after Part 2 is visible. Evidence copies go to sender
            and recipient. The dispute window starts from actual recipient-provider delivery—not submission
            to SES. No objection is not the same as acceptance.
          </p>
        </div>
      </div>
      <p className="mt-5 rounded-lg border border-[#dfd3b8] bg-[#fffaf0] p-4 text-xs leading-5 text-[#665a40]">
        OPP attributes authenticated actions to the frozen digital email identities and reports the exact factors
        used for each event. Contractual capacity, organizational authority, enforceability, and any required
        transaction formalities remain separate questions.
      </p>
    </section>
  )
}
